var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson34(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#E6E8EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 18C18.875 18 18.4688 18.5 17 18.5C15.5 18.5 15.0938 18 14.1875 18C11.875 18 10 19.9062 10 22.2188V23.5C10 24.3438 10.6562 25 11.5 25H22.5C23.3125 25 24 24.3438 24 23.5V22.2188C24 19.9062 22.0938 18 19.7812 18ZM23 23.5C23 23.7812 22.75 24 22.5 24H11.5C11.2188 24 11 23.7812 11 23.5V22.2188C11 20.4375 12.4062 19 14.1875 19C14.8125 19 15.4062 19.5 17 19.5C18.5625 19.5 19.1875 19 19.7812 19C21.5625 19 23 20.4375 23 22.2188V23.5ZM17 17C19.1875 17 21 15.2188 21 13C21 10.8125 19.1875 9 17 9C14.7812 9 13 10.8125 13 13C13 15.2188 14.7812 17 17 17ZM17 10C18.625 10 20 11.375 20 13C20 14.6562 18.625 16 17 16C15.3438 16 14 14.6562 14 13C14 11.375 15.3438 10 17 10Z",
    fill: "#6B7280"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#E6E8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson34);
export default __webpack_public_path__ + "static/media/person34.52231e6da2bd63cdcefd502982e6043b.svg";
export { ForwardRef as ReactComponent };